<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
}
</script>

<style>
@font-face {
  font-family: 'Sans';
  src: url('../src/assets/fonts/PlusJakartaSans-Regular.ttf');
}

@font-face {
  font-family: 'Poppins';
  src: url('../src/assets/fonts/Poppins-Regular.ttf');
}

@font-face {
  font-family: 'PlayBall';
  src: url('../src/assets/fonts/Playball-Regular.ttf');
}

:root {
  --primary-bg-color: #000002;
  --primary-text-color: #fff;
  --secondary-text-color: #8E8EA0;
}

* {
  font-family: 'Sans';
  color: var(--primary-text-color)
}

.toaster-card {
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #252626;
}

.toaster-text {
  color: #fff;
  font-size: 16px;
}

.toaster-card img {
  width: 24px;
  height: 24px;
}
</style>
